export default __webpack_public_path__ + "static/media/2.fb308c63.png";